// URL HELPER FUNCTIONS

/**
 * Format a Yii controller action URL with the current language-country segments prepended.
 *
 * @param action {string}
 * @return {string}
 */
export function formatActionUrl(action) {
   if (typeof window.localeUriSegment !== 'string' || window.localeUriSegment === '') {
      var pathname_parts = window.location.pathname.split('/')
      window.localeUriSegment = pathname_parts[1];
      let localeUriSegment = pathname_parts[1];

      if(!localeUriSegment.includes('en-de') && !localeUriSegment.includes('de-de')) {
         localeUriSegment = 'de-de';
      }

      if(pathname_parts[2] === 'deli') {
         localeUriSegment += `/${pathname_parts[2]}`
      }

      window.localeUriSegment = localeUriSegment;
   }

   return '/' + [window.localeUriSegment, 'actions', action].join('/');
}

/**
 * Add a query param and its value to the URL.
 *
 * @param key {string}
 * @param value {string}
 */
export function insertUrlParam(key, value) {
   if (history.pushState) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, value);
      let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
      window.history.pushState({path: newurl}, '', newurl);
   }
}

/**
 * Remove a query param from the URL by its key.
 *
 * @param key {string}
 */
export function removeUrlParam(key) {
   const url = new URL(window.location.href);
   url.searchParams.delete(key);
   const newUrl = url.href;
   window.history.pushState({ path: newUrl }, '', newUrl);
}

/**
 * Add an event listener that will persist UTM query params in the URL when linking to other
 * pages on the website.
 */
export function addUtmEventListener() {
   document.addEventListener('click', function(e){
      let aTag = e.target.closest('a');
      if (aTag !== null) {
         let urlParams = new URLSearchParams(window.location.search);
         let aParams = new URLSearchParams(aTag.search);

         // update the <a> tag's params with UTM params
         for (let [name, value] of urlParams.entries()) {

            // skip duplicates and only add new params that belong to UTM
            if (! aParams.has(name) && name.includes('utm_')) {
               aParams.append(name, value);
            }
         }

         // reset the anchor's URL with all the query params added
         aTag.href = aTag.href.split('?')[0] + '?' + aParams.toString();
      }
   });
}